import CorrectorEditor from "./CorrectorEditor";

export default CorrectorEditor;
